/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '../index';

const findAllOccasions = (brand, whichMessageVariant = 'TEXT') => {
    const fetchIcons = whichMessageVariant === 'ICONS' ? `
    iconImage {
        title
        href
    }` : '';
    return gql`{ findAllOccasions(brand: "${brand}", environment: "${GRAPHQL_ENV}") {
            cardCategory
            code
            displayType
            ${fetchIcons}
            messageText
            name
            rank
            uid
            __typename
        }
    }
`;
};

export default findAllOccasions;
